"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserInVenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../../enums");
const Intention_dto_1 = require("../Intention.dto");
class UserInVenueDto {}
exports.UserInVenueDto = UserInVenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "conversationPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserInVenueDto.prototype, "appVersion", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserInVenueDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "isInternal", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the user photo passed Ivy photo verification.'
}), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "isPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserInVenueDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UserInVenueDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether preferred genders should be shown on the viewer UI.'
}), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UserInVenueDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UserInVenueDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "isBlockingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "isBlockedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "isLikingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Boolean)], UserInVenueDto.prototype, "isLikedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], UserInVenueDto.prototype, "secondsInVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UserInVenueDto.prototype, "vibeEmoji", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: Intention_dto_1.IntentionDto
}), __metadata("design:type", Object)], UserInVenueDto.prototype, "intention", void 0);
//# sourceMappingURL=UserInVenue.dto.js.map